module.exports = __webpack_public_path__ + "img/calendar-primary.6af0e1a.png";